export enum LoanStatus {
  SUCCESS = 'SUCCESS',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  PENDING_SYSTEM = 'PENDING_SYSTEM',
  IN_TRANSITION = 'IN_TRANSITION',
  SOFT_DECLINE = 'SOFT_DECLINE',
  HARD_DECLINE = 'HARD_DECLINE',
  FATAL_ERROR = 'FATAL_ERROR',
  ERROR = 'ERROR',
}

export enum StateRequirementStatus {
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  UNRECOVERABLE = 'UNRECOVERABLE',
  ERROR = 'ERROR',
}

export enum RequirementName {
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
}

export interface Requirement<TData = unknown> {
  name: string;
  type: string;
  status: StateRequirementStatus;
  data?: TData;
}

export interface WorkflowState {
  loanStatus: LoanStatus;
  requirements: Requirement[];
}

export interface EmailVerificationRequirementData {
  pendingEmail: string;
  customerMerge: boolean;
}

export interface RequirementDataMap {
  [RequirementName.EMAIL_VERIFICATION]: EmailVerificationRequirementData;
}
